import { useMemo } from 'react';

// Radar charts look weird with less than 3 points, so we should only show them when there are 3 or more points
export const useShouldShowRadarChart = (pointCount: number | undefined) => {
  return useMemo(() => (pointCount ?? 0) > 2, [pointCount]);
};
